import { useQuery } from "@tanstack/react-query";
import { getUserPreferences } from "../../api/userPreferences";

export const USER_PREFERENCES_QUERY_KEY = ["userPreferences"] as const;

export function useUserPreferences() {
  return useQuery({
    queryKey: USER_PREFERENCES_QUERY_KEY,
    queryFn: getUserPreferences,
    staleTime: 30_000,
  });
}
